import type {BusinessCaseSignalPolicy} from '../types/BusinessCaseSignalPolicy';
import {BUSINESS_CASE_SIGNAL_CODES} from './BUSINESS_CASE_SIGNAL_CODES';
import {BUSINESS_CASE_SIGNAL_FOCUS_TIERS} from './BUSINESS_CASE_SIGNAL_FOCUS_TIERS';
import {DEFAULT_BUSINESS_CASE_AWAITING_REPLY_MINIMUM_HOURS} from './DEFAULT_BUSINESS_CASE_AWAITING_REPLY_MINIMUM_HOURS';
import {DEFAULT_BUSINESS_CASE_COLD_THRESHOLD_DAYS} from './DEFAULT_BUSINESS_CASE_COLD_THRESHOLD_DAYS';
import {DEFAULT_BUSINESS_CASE_OFFER_EXPIRING_DAYS} from './DEFAULT_BUSINESS_CASE_OFFER_EXPIRING_DAYS';
import {DEFAULT_BUSINESS_CASE_OFFER_NOT_SENT_MINIMUM_DAYS} from './DEFAULT_BUSINESS_CASE_OFFER_NOT_SENT_MINIMUM_DAYS';
import {DEFAULT_BUSINESS_CASE_OFFER_SENT_NO_RESPONSE_MINIMUM_DAYS} from './DEFAULT_BUSINESS_CASE_OFFER_SENT_NO_RESPONSE_MINIMUM_DAYS';
import {DEFAULT_BUSINESS_CASE_PAYMENT_UNPAID_MINIMUM_DAYS} from './DEFAULT_BUSINESS_CASE_PAYMENT_UNPAID_MINIMUM_DAYS';
import {DEFAULT_BUSINESS_CASE_TEST_DRIVE_FOLLOW_UP_MINIMUM_DAYS} from './DEFAULT_BUSINESS_CASE_TEST_DRIVE_FOLLOW_UP_MINIMUM_DAYS';
import {DEFAULT_BUSINESS_CASE_TEST_DRIVE_SOON_HOURS} from './DEFAULT_BUSINESS_CASE_TEST_DRIVE_SOON_HOURS';

export const DEFAULT_BUSINESS_CASE_SIGNAL_POLICY: BusinessCaseSignalPolicy = {
  coldThresholdDays: DEFAULT_BUSINESS_CASE_COLD_THRESHOLD_DAYS,
  awaitingReplyMinimumHours: DEFAULT_BUSINESS_CASE_AWAITING_REPLY_MINIMUM_HOURS,
  offerNotSentMinimumDays: DEFAULT_BUSINESS_CASE_OFFER_NOT_SENT_MINIMUM_DAYS,
  offerSentNoResponseMinimumDays: DEFAULT_BUSINESS_CASE_OFFER_SENT_NO_RESPONSE_MINIMUM_DAYS,
  offerExpiringDays: DEFAULT_BUSINESS_CASE_OFFER_EXPIRING_DAYS,
  testDriveFollowUpMinimumDays: DEFAULT_BUSINESS_CASE_TEST_DRIVE_FOLLOW_UP_MINIMUM_DAYS,
  testDriveSoonHours: DEFAULT_BUSINESS_CASE_TEST_DRIVE_SOON_HOURS,
  paymentUnpaidMinimumDays: DEFAULT_BUSINESS_CASE_PAYMENT_UNPAID_MINIMUM_DAYS,
  enabledSignalCodes: BUSINESS_CASE_SIGNAL_CODES,
  focusSignalOrder: BUSINESS_CASE_SIGNAL_FOCUS_TIERS.flat(),
};
